import i18n from 'scoreboard/components/i18n'
import FormsEdit from './forms-edit'
import Backbone from 'backbone'
import conductor from '../../components/conductor'

const DialogsEditDatasetForm = FormsEdit.extend({

	tagName: 'form',

	className: 'table-hack display-layout form forms-edit-view',

	/** @type {Form} */
	model: null,

	initialize: function(options = {}) {
		this.options = options
		this.model.set('label', i18n.get('forms.newDialog'))

		FormsEdit.prototype.initializeFormView.call(this)
	},

	renderEditButtons: function() {
		FormsEdit.prototype.renderEditButtons.call(this)

		// Due to render order, explicitly setting cancel listener here is
		// necessary for the cancel button to work
		this.listenTo(this.editButtons, 'cancel', this.onClickCancel)
	},

	getData() {
		return {
			...FormsEdit.prototype.getData.call(this),
			// Creating a descendant of PagesEdit requires an empty widgets array
			widgets: []
		}
	},

	onSubmitSuccess(model) {
		this.trigger('save', model)
		Backbone.trigger('add:domain-object', model)
		this.formView.start({isNew: false})
		conductor.navigate(`forms/${model.id}/edit`,
			{ trigger: true })
	},
})

export default DialogsEditDatasetForm

DialogsEditDatasetForm.__filename__ = 'forms/edit/dialogs-edit-dataset-form.js'
